import { useQuery, useQueryClient } from '@tanstack/react-query'
import { userKeys } from './keys'
import { getMyProfile } from 'api/user'
import { useAuthContext } from 'components/auth'
import { QueryOptions } from 'queries/types'

export function useUserProfile(
  options: QueryOptions<typeof getMyProfile> = {}
) {
  const { user } = useAuthContext()
  return useQuery({
    ...options,
    queryKey: userKeys.profile(user?.uid),
    queryFn: getMyProfile,
  })
}

export function useInvalidateUserProfile() {
  const queryClient = useQueryClient()
  const { user } = useAuthContext()
  return {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: userKeys.profile(user?.uid),
      }),
  }
}
